<template>
  <el-select
      v-model="chargeCodeSelected"
      @change="handleChange"
      :placeholder="$t('tariff.chargeCodes.placeholder.chargeCodeType')"
      :disabled="disabled"
  >
      <el-option
          v-for="option in chargeCodeType"
          :key="option.value"
          :label="option.label"
          :value="option.label"
      />
  </el-select>
</template>
<script>
import constants from '@/utils/constants';

export default {
  name: 'ChargeCodeTypeSelect',
  computed: {
    chargeCodeType() {
      if (this.defaultAll) {
        return [...constants.CHARGE_CODE.CHARGE_CODE_TYPES];
      }
      return constants.CHARGE_CODE.CHARGE_CODE_TYPES;
    },
    chargeCodeSelected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    defaultAll: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    reset() {
      this.dayOfServiceSelected = null;
      this.$emit('input', null);
      this.$emit('change', null);
    },
    handleChange(value) {
      this.$emit('change', value);
    }
  }
};
</script>
